export const DISCOVERY_AI_FILTERS = [
  'all', 'human', 'assisted', 'generated', 'no_generated', 'undeclared'
];

const unique = values => [...new Set(values.filter(Boolean))];

export const parseDiscoveryState = search => {
  const params = new URLSearchParams(search || '');
  const legacyLanguages = (() => {
    if (params.has('lang') && params.getAll('lang').length === 1) {
      const raw = params.get('lang');
      if (raw?.startsWith('[')) {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch { return []; }
      }
    }
    return params.getAll('lang');
  })();
  const scope = ['all', 'for-you', 'paid'].includes(params.get('scope'))
    ? params.get('scope') : 'all';
  const sort = ['newest', 'shortest'].includes(params.get('sort'))
    ? params.get('sort') : 'newest';
  const ai = DISCOVERY_AI_FILTERS.includes(params.get('ai'))
    ? params.get('ai') : 'all';
  const pageValue = Number(params.get('page'));
  const page = Number.isSafeInteger(pageValue) && pageValue > 0 ? pageValue : 1;
  const cursor = (params.get('cursor') || '').slice(0, 2048);
  const trail = params.getAll('prev').map(value => value.slice(0, 2048));
  const q = (params.get('q') || params.get('search') || '').slice(0, 100);
  const genres = unique(params.getAll('genre'));
  const languages = unique(legacyLanguages);
  const view = params.get('view') === 'results' || scope !== 'all' ||
    !!q || !!genres.length || !!languages.length || ai !== 'all'
    ? 'results' : 'home';
  return {view, scope, q, genres, languages, ai, sort, page, cursor, trail};
};

export const discoverySearch = state => {
  const params = new URLSearchParams();
  if (state.view === 'results') params.set('view', 'results');
  if (state.scope !== 'all') params.set('scope', state.scope);
  if (state.q) params.set('q', state.q.slice(0, 100));
  unique(state.genres || []).forEach(genre => params.append('genre', genre));
  unique(state.languages || []).forEach(lang => params.append('lang', lang));
  if (state.ai !== 'all') params.set('ai', state.ai);
  if (state.sort !== 'newest') params.set('sort', state.sort);
  if (state.page > 1) params.set('page', String(state.page));
  if (state.page > 1 && state.cursor) params.set('cursor', state.cursor);
  if (state.page > 1) (state.trail || []).forEach(value => params.append('prev', value));
  return params.toString();
};

export const discoveryPath = state => {
  const search = discoverySearch(state);
  return `/discover${search ? `?${search}` : ''}`;
};
